import styles from "./footer-main.module.css"
import { NavLink } from "react-router-dom"
import { useSelector } from "react-redux"

function FooterMain() {
  const isAuthChecked = useSelector((store) => store.user.isAuthChecked)

  return (
    <footer className={styles.footer}>
      <div className={styles.containerWrapper}>
        <div className={styles.logoPhone}></div>
        <div className={styles.container}>
          <div className={styles.logo}></div>
          <ul className={styles.textContainer}>
          <li>
              <NavLink to={"/"} className={styles.link}>
                <button className={styles.buttonHeader}>
                  <span className={styles.text}>Главная</span>
                </button>
              </NavLink>
            </li>
            <li>
              <NavLink to={"/analytics-and-news"} className={styles.link}>
                <button className={styles.buttonHeader}>
                  <span className={styles.text}>Новости и аналитика</span>
                </button>
              </NavLink>
            </li>
            {/*
                        <li>
                            <NavLink to={'/info'} className={styles.link}>
                                <button className={styles.buttonHeader}>
                                    <span className={styles.text}>Информационные страницы</span>
                                </button>
                            </NavLink>
                        </li>
                        */}
            {/*
                        <li>
                            <NavLink to={'/products'} className={styles.link}>
                                <button className={styles.buttonHeader}>
                                    <span className={styles.text}>Продукты</span>
                                </button>
                            </NavLink>
                        </li>
                        */}
            <li>
              <NavLink to={"/education"} className={styles.link}>
                <button className={styles.buttonHeader}>
                  <span className={styles.text}>Обучение</span>
                </button>
              </NavLink>
            </li>
            <li>
              <NavLink to={"/tables"} className={styles.link}>
                <button className={styles.buttonHeader}>
                  <span className={styles.text}>Портфели</span>
                </button>
              </NavLink>
            </li>
              <li>
                <NavLink to={"/profile"} className={styles.link}>
                  <button className={styles.buttonHeader}>
                    <span className={styles.text}>Профиль</span>
                  </button>
                </NavLink>
              </li>
              <li>
                <NavLink to={"/about-us"} className={styles.link}>
                  <button className={styles.buttonHeader}>
                    <span className={styles.text} style={{"white-space": "nowrap"}}>О нас</span>
                  </button>
                </NavLink>
              </li>
          </ul>
          <div className={styles.logos}>
            <a
              href={"https://t.me/ie_contact"}
              target="_blank"
              className={styles.footerLink}
            >
              <div className={styles.logoTg}></div>
            </a>

            <a
              href={"https://www.youtube.com/@investera3816"}
              target="_blank"
              className={styles.footerLink}
            >
              <div className={styles.logoYt}></div>
            </a>
          </div>
        </div>
        <div className={styles.confide}>
          <span className={styles.textFooter}>
            Все материалы, представленные <br /> на сайте, не являются
            инвестиционной <br /> рекомендацией.
          </span>
          <span className={styles.copyright}>
            &copy; ИП Артём Николаев, 2024. Все права защищены.
          </span>
        </div>
      </div>
    </footer>
  )
}

export default FooterMain
